import ClassDocumentItem from './ClassDocumentItem';

export default ClassDocumentItem;
